<script setup lang="ts">
    export interface KlarnaProps {
        amount?: number;
        region: string;
        isoCode: string;
    }
    const props = defineProps<KlarnaProps>();

    const getID = computed(() => {
        return {
            DE: 'ccac0834-da15-53f3-9a8c-58cc2eebbb67',
            AT: 'b22e6bee-ba65-514a-a84c-8ac82ded3013',
            CH: '74e3adc6-4bfb-596f-b6c5-756cb407fcf0',
            FR: '93d667f4-ebe6-5e0c-9b26-a5f666337f51',
            IT: '7ab9ad34-33e7-5ae2-8a8e-f579f6aed9a0',
            SE: '4667f9bd-7c1e-51e9-b14e-814a472058c7',
            DK: 'e40dfa9a-3cef-5580-a143-1ea302e98a90',
            NL: 'f494cb1f-f593-5a39-9213-4efecade13eb',
        }[props.region.toUpperCase()];
    });

    const klarnaPlacement = computed(() => {
        return `<klarna-placement
            data-key="credit-promotion-badge"
            data-locale="${props.isoCode}"
            data-purchase-amount="${props.amount?.toFixed()}">
            </klarna-placement>`;
    });

    watch(klarnaPlacement, () => {
        if (window?.Klarna) {
            refreshKlarna();
        }
    });

    onBeforeMount(() => {
        init();
    });

    const init = () => {
        if (window && getID.value) {
            if (window?.Klarna?.OnsiteMessaging) {
                refreshKlarna();
                return;
            }
            const klarnaEnv = 'production';
            useHead({
                script: [
                    {
                        src: `https://js.klarna.com/web-sdk/v1/klarna.js`,
                        async: true,
                        'data-client-id': getID.value,
                        'data-environment': klarnaEnv,
                    },
                ],
            });
        }
    };
    const refreshKlarna = async () => {
        await wait();
        window.Klarna.OnsiteMessaging.refresh();
    };
</script>
<template>
    <div
        v-if="getID && klarnaPlacement"
        class="atm-klarna">
        <div class="min-h-[70px]">
            <renderer-html :content="klarnaPlacement" />
        </div>
    </div>
</template>
